export { default as Heading, getNextHeadingTag } from "./Heading.deprecated";
export type { HeadingTag } from "./Heading.deprecated";
export { default } from "./Typography.deprecated";
